import React, { useState } from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Vision from '../components/Vision';
import Services from '../components/Services';
import BibleVerse from '../components/BibleVerse';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div>
      <Header />
      <Navigation />
      <Hero />
      <Vision />
      <Services />
      <BibleVerse 
        verse="Venez à moi, vous tous qui êtes fatigués et chargés, et je vous donnerai du repos. Prenez mon joug sur vous et recevez mes instructions, car je suis doux et humble de cœur; et vous trouverez du repos pour vos âmes. Car mon joug est doux, et mon fardeau léger."
        reference="Matthieu 11:28-30 / Matthew 11:28-30 / Matthäus 11:28-30"
      />
      <About />
      <Gallery />
      <BibleVerse 
        verse="Le Seigneur vous couvrira de biens dans le pays qu'il a promis à vos ancêtres de vous donner: vous aurez beaucoup d'enfants, vos troupeaux seront nombreux, vous aurez de belles récoltes."
        reference="Deutéronome 28:11-12 / Deuteronomy 28:11-12 / 5. Mose 28:11-12"
      />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
